/**
 * Recipe steps card builder (receta-pasos)
 *
 * Editor instructions for merchants/writers:
 *   docs/COMO-ESCRIBIR-UNA-RECETA.md
 *
 * Expected structure inside [data-receta-pasos]:
 *   Heading (H2/H3/H4) → Image → one or more Paragraphs  (repeat per step)
 *   Image may be: bare <img>, <p> wrapping only an <img>, or <figure> (optional <figcaption>).
 *
 * A step = heading + media + all following <p> until the next heading.
 * Loose nodes get .receta-pasos__loose (grid-column: 1 / -1), not a card cell.
 * Zero complete steps → DOM untouched (CSS fallback) + console warning.
 *
 * Loaded with defer from sections/receta-pasos.liquid (after the content markup).
 */
(function () {
  var root = document.querySelector('[data-receta-pasos]');
  if (!root) return;

  function isHeading(n) {
    return n && n.nodeType === 1 && /^H[234]$/.test(n.tagName);
  }

  function mediaFrom(n) {
    if (!n || n.nodeType !== 1) return null;
    if (n.tagName === 'IMG') return { node: n, drop: null };
    if (n.tagName === 'FIGURE' && n.querySelector('img')) return { node: n, drop: null };
    if (n.tagName === 'P') {
      var img = n.querySelector('img');
      if (img && !n.textContent.trim()) return { node: img, drop: n };
    }
    return null;
  }

  function isDescParagraph(n) {
    return n && n.tagName === 'P' && !mediaFrom(n);
  }

  var children = Array.prototype.slice.call(root.children);
  var out = [];
  var cards = 0;
  var i = 0;

  while (i < children.length) {
    var heading = children[i];
    var media = isHeading(heading) ? mediaFrom(children[i + 1]) : null;

    if (isHeading(heading) && media) {
      var paras = [];
      var j = i + 2;
      while (j < children.length && isDescParagraph(children[j])) {
        paras.push(children[j]);
        j += 1;
      }
      out.push({
        card: true,
        heading: heading,
        media: media.node,
        drop: media.drop,
        paras: paras
      });
      cards += 1;
      i = j;
    } else {
      out.push({ card: false, node: children[i] });
      i += 1;
    }
  }

  if (!cards) {
    console.warn('receta-pasos: no se detectaron pasos, revisa la estructura del artículo');
    return;
  }

  var grid = document.createElement('div');
  grid.className = 'receta-pasos__grid';

  out.forEach(function (item) {
    if (item.card) {
      var card = document.createElement('article');
      card.className = 'receta-paso-card';
      card.appendChild(item.heading);
      card.appendChild(item.media);
      item.paras.forEach(function (p) { card.appendChild(p); });
      if (item.drop && item.drop.parentNode) item.drop.parentNode.removeChild(item.drop);
      grid.appendChild(card);
    } else {
      var wrap = document.createElement('div');
      wrap.className = 'receta-pasos__loose';
      wrap.appendChild(item.node);
      grid.appendChild(wrap);
    }
  });

  while (root.firstChild) root.removeChild(root.firstChild);
  root.appendChild(grid);
  root.setAttribute('data-receta-pasos-ready', '');
})();
